module.exports = __webpack_public_path__ + "img/logo_bayer.27da6cdd.png";